import { useState, useEffect, useRef, useCallback } from "react";
import { toast } from "sonner";
import { STORAGE_KEY, DEFAULT_WIDTH, MIN_WIDTH } from "@/components/tableau/utils/constants";

export function useResize({ columnWidths, setColumnWidths }) {
  const [resizing, setResizing] = useState(null);
  const resizingRef = useRef(null);
  const startX = useRef(0);
  const startWidth = useRef(0);

  const handleResizeStart = useCallback((e, columnName) => {
    e.preventDefault();
    e.stopPropagation();
    resizingRef.current = columnName;
    startX.current = e.clientX;
    startWidth.current = columnWidths[columnName] || DEFAULT_WIDTH;
    setResizing(columnName);
  }, [columnWidths]);

  const handleResizeMove = useCallback((e) => {
    if (!resizingRef.current) return;
    const diff = e.clientX - startX.current;
    const newWidth = Math.max(MIN_WIDTH, startWidth.current + diff);
    setColumnWidths(prev => ({ ...prev, [resizingRef.current]: newWidth }));
  }, [setColumnWidths]);

  const handleResizeEnd = useCallback(() => {
    resizingRef.current = null;
    setResizing(null);
  }, []);

  useEffect(() => {
    if (resizing) {
      document.addEventListener('mousemove', handleResizeMove);
      document.addEventListener('mouseup', handleResizeEnd);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    }
    return () => {
      document.removeEventListener('mousemove', handleResizeMove);
      document.removeEventListener('mouseup', handleResizeEnd);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [resizing, handleResizeMove, handleResizeEnd]);

  const resetColumnWidths = useCallback(() => {
    setColumnWidths({});
    localStorage.removeItem(STORAGE_KEY);
    toast.success("Largeurs des colonnes réinitialisées");
  }, [setColumnWidths]);

  return { resizing, handleResizeStart, handleResizeMove, handleResizeEnd, resetColumnWidths };
}
